.kq{padding:0.375rem;}